import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UserAuthService } from '../services/user-auth.service';
import { DataLayerService } from '../services/datalayer.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly cookieService: CookieService,
    private readonly userAuthService: UserAuthService, 
    private readonly dataLayerService: DataLayerService
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

  if (localStorage.getItem('loginUrl')!="") 
  {
    if (!localStorage.getItem('isLoginSuccess')) 
    {

      localStorage.setItem('isLoginSuccess', 'true');
      localStorage.setItem('loginUrl',"");
      this.dataLayerService.dataLayerCallback(true, 'LoginSuccess');
    }
    return true;
  } 
  else if (this.userAuthService.getAccessToken()) {
    return true;
  } else {
    //Allow new user to access article page
    if(next.queryParamMap.get("IsExisting")=="false") return true;
    else if(next.queryParamMap.get("IsExisting")=="true"){
      this.router.navigate(['/login'],{queryParams:{returnUrl:state.url}, replaceUrl: true});
      return false;
    }
    this.router.navigate(['/login'], { replaceUrl: true });
    return false;
  }
  }
}
